<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$viewAccess($route.fullPath)">
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                <v-icon class="me-2">mdi-clock-alert-outline</v-icon>
                Late & Early Leave Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="loadReport" ref="filterForm">
                  <v-row class="py-3 px-3" align="end">
                    <v-col cols="12" sm="6" md="3">
                      <v-date-input
                          input-format="dd/mm/yyyy"
                          v-model="filters.from_date"
                          label="From Date"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          hide-details="auto"
                          required
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-date-input
                          input-format="dd/mm/yyyy"
                          v-model="filters.to_date"
                          label="To Date"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          hide-details="auto"
                          required
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-autocomplete
                          v-model="filters.employee_id"
                          :items="employees"
                          :item-title="item => `${item.name}-(${item.code})` ?? 'N/A'"
                          item-value="id"
                          label="Employee (Optional)"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          clearable
                          hide-details="auto"
                          :loading="employeesLoading"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" class="d-flex align-end">
                      <v-btn
                          type="submit"
                          color="primary"
                          variant="flat"
                          :loading="loading"
                          prepend-icon="mdi-magnify"
                          density="compact"
                          height="40"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Summary Cards -->
          <!-- <v-row v-if="reportData.length > 0" class="mb-3 pa-3">
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="primary">
                <v-card-text>
                  <div class="text-caption text-black">Total Late Count</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalLateCount }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="warning">
                <v-card-text>
                  <div class="text-caption text-black">Total Early Count</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalEarlyCount }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="error">
                <v-card-text>
                  <div class="text-caption text-black">Total Late Hours</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalLateHours.toFixed(2) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-card variant="outlined" color="success">
                <v-card-text>
                  <div class="text-caption text-black">Total Working Hours</div>
                  <div class="text-h5 text-black font-weight-bold">
                    {{ totalWorkingHours.toFixed(2) }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row> -->

          <!-- Report Table -->
          <v-expansion-panels v-model="reportPanel" class="mt-3">
            <v-expansion-panel>
              <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
                  expand-icon="mdi-chevron-down"
              >
                <v-icon class="me-2">mdi-table</v-icon>
                Report Data
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                        v-model="search"
                        append-inner-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        class="pl-2"
                        clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                          v-if="reportData.length > 0"
                          variant="outlined"
                          density="compact"
                          size="x-small"
                          divided
                      >
                        <v-btn
                            prepend-icon="mdi mdi-download"
                            variant="flat"
                            color="success"
                            @click="exportToExcel"
                            :disabled="!reportData.length"
                        >EXCEL</v-btn
                        >
                        <v-btn
                            prepend-icon="mdi mdi-download"
                            variant="flat"
                            color="red"
                            @click="exportToPDF"
                            :disabled="!reportData.length"
                        >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12"></v-col>
                </v-row>

                <v-data-table
                    :headers="headers"
                    :items="filteredReportDataWithSl"
                    :loading="loading"
                    item-value="employee_code"
                    class="elevation-0 table-bordered"
                    :items-per-page="25"
                    :items-per-page-options="[10, 25, 50, 100]"
                >
                  <template v-slot:item.sl="{ item }">
                    <div class="text-center">{{ item.sl }}</div>
                  </template>

                  <template v-slot:item.month="{ item }">
                    <span class="font-weight-medium">{{ item.month }}</span>
                  </template>

                  <template v-slot:item.employee_code="{ item }">
                    <div>{{ item.employee_code || '-' }}</div>
                  </template>

                  <template v-slot:item.employee_name="{ item }">
                    <div class="font-weight-medium">{{ item.employee_name || '-' }}</div>
                  </template>

                  <template v-slot:item.total_late_count="{ item }">
                    <v-chip
                        :color="item.total_late_count > 0 ? 'error' : 'success'"
                        size="small"
                        variant="text"
                    >
                      {{ item.total_late_count }}
                    </v-chip>
                  </template>

                  <template v-slot:item.total_early_count="{ item }">
                    <v-chip
                        :color="item.total_early_count > 0 ? 'warning' : 'success'"
                        size="small"
                        variant="text"
                    >
                      {{ item.total_early_count }}
                    </v-chip>
                  </template>

                  <template v-slot:item.total_late_hours="{ item }">
                    <div class="text-center">
                    <span :class="item.total_late_hours > 0 ? 'text-error font-weight-bold' : ''">
                      {{ item.total_late_hours.toFixed(2) }}
                    </span>
                    </div>
                  </template>

                  <template v-slot:item.total_working_hours="{ item }">
                    <div class="text-center">
                    <span class="text-success font-weight-medium">
                      {{ item.total_working_hours.toFixed(2) }}
                    </span>
                    </div>
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center pa-8">
                      <v-icon size="64" color="grey-lighten-1">mdi-database-off</v-icon>
                      <div class="text-h6 mt-4 text-grey">No data available</div>
                      <div class="text-caption text-grey">Please select date range and click Search</div>
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { toast } from 'vue3-toastify'
import { useStore } from 'vuex'
import { formatDateView, formatDateDash } from "@/plugins/helpers";


const store = useStore()
const instance = getCurrentInstance()
const appContext = instance?.appContext

// Loading states
const loading = ref(false)
const employeesLoading = ref(false)
const panel = ref([0])
const reportPanel = ref([0])
const search = ref('')

// Filters
const filters = ref({
  from_date: null,
  to_date: null,
  employee_id: null
})

// Data
const reportData = ref([])
const employees = ref([])

// Table headers
const headers = [
  { title: '# SL', key: 'sl', sortable: false, align: 'center' },
  { title: 'Month', key: 'month', sortable: false, align: 'center' },
  { title: 'Employee Code', key: 'employee_code', sortable: false, align: 'center' },
  { title: 'Employee Name', key: 'employee_name', sortable: false, align: 'center' },
  { title: 'Department', key: 'department', sortable: true, align: 'center' },
  { title: 'Designation', key: 'designation', sortable: false, align: 'center' },
  { title: 'Late Count', key: 'total_late_count', sortable: false, align: 'center' },
  { title: 'Early Count', key: 'total_early_count', sortable: false, align: 'center' },
  { title: 'Late Hours', key: 'total_late_hours', sortable: false, align: 'center' },
  { title: 'Working Hours', key: 'total_working_hours', sortable: false, align: 'center' }
]

const getCurrentCompany = computed(() => {
  return store.getters.getCurrentCompany || {}
})

const getFileServerUrl = computed(() => {
  return store.getters.getFileServerUrl || ''
})

// Computed summary
const totalLateCount = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_late_count || 0), 0)
})

const totalEarlyCount = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_early_count || 0), 0)
})

const totalLateHours = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_late_hours || 0), 0)
})

const totalWorkingHours = computed(() => {
  return reportData.value.reduce((sum, item) => sum + (item.total_working_hours || 0), 0)
})

const formatTime = (timeStr) => {
  if (!timeStr || timeStr === '-') return '-'
  const timeParts = timeStr.split(':')
  if (timeParts.length < 2) return timeStr
  const hours = parseInt(timeParts[0], 10)
  const minutes = timeParts[1]
  if (isNaN(hours)) return timeStr
  const period = hours >= 12 ? 'PM' : 'AM'
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours
  return `${displayHours}:${minutes} ${period}`
}

const formatNumber = (value, fraction = 0) => {
  if (value === undefined || value === null || isNaN(value)) return '-'
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction
  })
}

// Computed data with SL numbers
const reportDataWithSl = computed(() => {
  return reportData.value.map((item, index) => ({
    ...item,
    sl: index + 1
  }))
})

// Filtered report data with SL numbers based on search
const filteredReportDataWithSl = computed(() => {
  if (!search.value) {
    return reportDataWithSl.value
  }

  const searchLower = search.value.toLowerCase()
  return reportDataWithSl.value.filter(item => {
    const employeeCode = (item.employee_code || '').toLowerCase()
    const employeeName = (item.employee_name || '').toLowerCase()
    const month = (item.month || '').toLowerCase()
    return employeeCode.includes(searchLower) ||
        employeeName.includes(searchLower) ||
        month.includes(searchLower)
  })
})

// Methods
const loadEmployees = async () => {
  employeesLoading.value = true
  try {
    const response = await store.dispatch('getEmployees')
    if (response.data.success && response.data.data) {
      employees.value = response.data.data
    } else if (response.data.data) {
      employees.value = response.data.data
    } else {
      employees.value = []
    }
  } catch (error) {
    employees.value = []
    console.error('Error loading employees:', error)
  } finally {
    employeesLoading.value = false
  }
}

const loadReport = async () => {
  if (!filters.value.from_date || !filters.value.to_date) {
    toast.error('Please select both From Date and To Date')
    return
  }

  loading.value = true
  try {
    const params = {
      from_date: formatDateDash(filters.value.from_date),
      to_date: formatDateDash(filters.value.to_date)
    }

    if (filters.value.employee_id) {
      params.employee_id = filters.value.employee_id
    }

    const response = await store.dispatch('getLateEarlyReport', params)

    if (response.success) {
      reportData.value = response.data || []
      if (reportData.value.length === 0) {
        toast.info('No data found for the selected criteria')
      }
    } else {
      toast.error(response.message || 'Failed to load report')
      reportData.value = []
    }
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || 'Failed to load report')
    reportData.value = []
  } finally {
    loading.value = false
  }
}

const resetFilters = () => {
  const today = new Date()
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)

  filters.value = {
    from_date: firstDay,
    to_date: lastDay,
    employee_id: null
  }
  reportData.value = []
}

// Export to Excel
const exportToExcel = () => {
  if (!reportData.value.length) {
    toast.warning('No data to export')
    return
  }



  const data = [
    ['Late & Early Leave Report'],
    [`From Date: ${formatDateView(formatDateDash(filters.value.from_date))} to ${formatDateView(formatDateDash(filters.value.to_date))}`]
  ]

  if (filters.value.employee_id) {
    const selectedEmployee = employees.value.find(e => e.id === filters.value.employee_id)
    if (selectedEmployee) {
      data.push([`Employee: ${selectedEmployee.name || ''}${selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id ? ` (${selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id})` : ''}`])
    }
  }

  data.push([], ['# SL', 'Month', 'Employee Code', 'Employee Name', 'Department', 'Designation', 'Late Count', 'Early Count', 'Late Hours', 'Working Hours'], [])

  // Add data rows
  reportData.value.forEach((row, index) => {
    data.push([
      index + 1,
      row.month || '-',
      row.employee_code || '-',
      row.employee_name || '-',
      row.department || '-',
      row.designation || '-',
      formatNumber(row.total_late_count),
      formatNumber(row.total_early_count),
      formatNumber(row.total_late_hours, 2),
      formatNumber(row.total_working_hours, 2)
    ])
  })

  const proxy = appContext?.config?.globalProperties
  if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
    proxy.$exportTableToExcel(data, 'late_early_report_' + proxy.$fileDate())
  }
}

/*
|--------------------------------------------------------------------------
| Export PDF
|--------------------------------------------------------------------------
|
| Header and footer are table rows exactly like
| the attendance summary report print structure.
|
*/

const exportToPDF = async () => {

  if (!filteredReportDataWithSl.value.length) {

    toast.warning(
        'No data to export'
    )

    return
  }


  const company =
      getCurrentCompany.value

  const fileServerUrl =
      getFileServerUrl.value


  const selectedEmployee =
      filters.value.employee_id
          ? employees.value.find(
              e => e.id === filters.value.employee_id
          )
          : null


  const printWindow = window.open(
      '',
      '_blank',
      `width=${screen.width}, height=${screen.height}`
  )


  const printContent = `

    <!DOCTYPE html>

    <html>

      <head>

        <meta charset="UTF-8">

        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        >

        <meta
          http-equiv="X-UA-Compatible"
          content="ie=edge"
        >

        <title>
          Late & Early Leave Report
        </title>


        <link
          href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css"
          rel="stylesheet"
        >

        <style>

          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          @page {
            size: A4;
            margin: 0;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: auto;
          }

          body {
            font-family: Arial, Helvetica, sans-serif;
            background: #fff;
            color: #000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .report-container {
            width: 100%;
          }

          table.master-table {
            width: 100%;
            border-collapse: collapse;
          }

          .company-info {
            flex: 1;
            min-width: 0;
          }

          .company-name {
            font-size: 13px;
            font-weight: bold;
            text-transform: uppercase;
            margin-bottom: 4px;
          }

          .company-text {
            font-size: 11px;
            margin: 2px 0;
            line-height: 1.35;
          }

          .logo-container {
            width: 160px;
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
          }

          .logo-container img {
            max-height: 75px;
            max-width: 150px;
            object-fit: contain;
          }

          .header-row td {
            padding: 15px 32px 10px 32px;
            border-bottom: 2px solid #eee;
          }

          .footer-row td {
            padding: 8px 32px 10px 32px;
            border-top: 1px solid #eee;
          }

          .invoice-footer {
            margin-top: auto;
            position: fixed;
            left: 0;
            bottom: 0px;
            width: 100%;
          }

          .invoice-footer p {
            font-size: 11px;
            font-weight: 500;
            margin: 3px 0;
            display: flex;
            align-items: center;
            gap: 4px;
            line-height: 1.25;
          }

          .report-title {
            font-size: 16px;
            text-align: center;
            text-decoration: underline;
            font-weight: bold;
            margin: 10px 0 15px 0;
          }

          .report-info {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            font-size: 12px;
          }

          .report-info-left {
            text-align: left;
          }

          .report-info-right {
            text-align: right;
          }

          .report-info p {
            margin: 3px 0;
          }

          table.attendance-table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            font-size: 10px;
            background: #fff;
          }

          .attendance-table thead {
            display: table-header-group;
          }


          .attendance-table tfoot {
            display: table-footer-group;
          }

          .attendance-table th,
          .attendance-table td {
            border: 1px solid #000;
            padding: 5px 4px;
            vertical-align: middle;
          }

          .attendance-table th {
            background: #e0e0e0;
            text-align: center;
            font-weight: bold;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .attendance-table td {
            text-align: left;
          }


          .text-center {
            text-align: center;
          }

          .text-right {
            text-align: right;
          }

          .attendance-table tr {
            page-break-inside: avoid;
          }

          .attendance-table {
            page-break-inside: auto;
          }


          .attendance-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          @media print {
            body {
              margin: 0;
              padding: 0;
            }

            .body-row td {
              padding: 0 32px;
            }

            .header-row {
              display: table-header-group;
            }

            .footer-row {
              display: table-footer-group;
            }

            .attendance-table thead {
              display: table-header-group;
            }

            .attendance-table tr {
              page-break-inside: avoid;
            }

          }

        </style>

      </head>


      <body>

        <div class="report-container">
          <table class="master-table">
            <thead>
              <tr>
                <td colspan="100%">
                  <div>
                    <div style="display: flex; justify-content: flex-end; align-items: flex-start; padding-bottom: 10px; margin-bottom: 16px;">
                      <img
                        src="${fileServerUrl}${company.logo}"
                        class="logo-img"
                        alt="Logo"
                        style="max-height: 80px;"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr class="body-row">
                <td>

                  <div class="report-title">
                    LATE &amp; EARLY LEAVE REPORT
                  </div>


                  <div class="report-info">
                    <div class="report-info-left">
                      <p>
                        <strong>Period:</strong> ${formatDateView(formatDateDash(filters.value.from_date))} to ${formatDateView(formatDateDash(filters.value.to_date))} </p>

                      ${selectedEmployee
      ? `
                            <p>
                              <strong>Employee:</strong>
                              ${selectedEmployee.name || ''}
                              ${ (selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id)
          ? ` (${selectedEmployee.employee_code || selectedEmployee.code || selectedEmployee.emp_id})`
          : ''
      }
                            </p>
                          `
      : ''
  }

                    </div>

                    <div class="report-info-right">
                      <p><strong>Total Records:</strong>${filteredReportDataWithSl.value.length}</p>
                    </div>

                  </div>

                  <table class="attendance-table">
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Month</th>
                        <th>Employee Code</th>
                        <th>Employee Name</th>
                        <th>Department</th>
                        <th>Designation</th>
                        <th>Late Count</th>
                        <th>Early Count</th>
                        <th>Late Hours</th>
                        <th>Working Hours</th>
                      </tr>
                    </thead>

                    <tbody>
                      ${filteredReportDataWithSl.value.map((row, index) => `
                        <tr>
                          <td class="text-center">${index + 1}</td>
                          <td>${row.month || '-'}</td>
                          <td>${row.employee_code || '-'}</td>
                          <td>${row.employee_name || '-'}</td>
                          <td>${row.department || '-'}</td>
                          <td>${row.designation || '-'}</td>
                          <td class="text-center">${formatNumber(row.total_late_count)}</td>
                          <td class="text-center">${formatNumber(row.total_early_count)}</td>
                          <td class="text-center">${formatNumber(row.total_late_hours, 2)}</td>
                          <td class="text-center">${formatNumber(row.total_working_hours, 2)}</td>
                        </tr>
                      `).join('')}
                    </tbody>
                  </table>

                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td colspan="100%" style="border:none">
                  <div style="width:100%;height: 100px;">&nbsp;</div>
                </td>
              </tr>
              <tr class="footer-row">
                <td>

                  <div class="invoice-footer" style="margin-left:10px; margin-bottom:10px; color: #343591;">
                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
                  </svg>

                  <span>${company?.address}</span>
                </p>

                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
                  </svg>

                  <strong>Phone: </strong>  +880 9610-993393, +880 2 222288648, www.remexingredient.com | www.remexcorp.com
                </p>
              </div>
                </td>
              </tr>
            </tfoot>
          </table>

        </div>

      </body>

    </html>
  `


  printWindow.document.write(
      printContent
  )

  printWindow.document.close()

  printWindow.focus()

  await new Promise(resolve =>
      setTimeout(resolve, 700)
  )

  printWindow.print()
  printWindow.close()
}

// Initialize
onMounted(async () => {
  await loadEmployees()
  resetFilters()
})
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}

.table-bordered :deep(th),
.table-bordered :deep(td) {
  border: 1px solid #000000 !important;
}

.table-bordered :deep(table) {
  border-collapse: collapse;
}

.gap-2 {
  gap: 8px;
}

.panel-header {
  font-weight: 600;
}
</style>